module.exports = __webpack_public_path__ + "static/media/Diet.a304426a.png";